import customAxios from './axios';
import CONFIG from '../../config';

export const getAllRefunds = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/PaymentRefunds/GetAll`, payload).then(res => {
        let response = res['data'];
        return response;
    })
}

export const getCsv = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/PaymentRefunds/GetCsv`, payload).then(res => {
        return res;
    })
}

export const updateStatus = (payload) => {
    return customAxios.post(CONFIG.apiURL + `/PaymentRefunds/UpdateRefundStatus`, payload).then(res => {
        return res;
    })
}

export const getRefundValues = () => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetAllRefundStautusValues`).then((res) => {
        let response = res['data'];
        return response;
    })
}

export const getRelevantRefundStautusValues = (refundId) => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetRelevantRefundStautusValues?refundId=${refundId}`).then((res) => {
        let response = res['data'];
        return response;
    })
}

export const getRefundInfo = (id) => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/Get?Id=${id}`).then((res) => {
        return res['data'];
    })
}

export const getRefundDocumentIds = (id) => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetRefundAttachments?Id=${id}`).then((res) => {
        return res['data'];
    });
}

export const uploadRca = (payload) => {
    return customAxios.put(CONFIG.apiURL + `/PaymentRefunds/UploadRca`, payload).then(res => {
        return res;
    })
}

export const uploadRefundReceipt = (payload) => {
    return customAxios.put(CONFIG.apiURL + `/PaymentRefunds/UploadRefundReceipt`, payload).then(res => {
        return res;
    })
}

export const refundStatusInfo = (jobId) => {
    return customAxios.get(CONFIG.apiURL + `/PaymentRefunds/GetRefundLogs?jobid=${jobId}`).then(res => {
        return res['data'];
    })
}
